import NewControlRepo from './NewControlRepo';

export default NewControlRepo;
